import { IConfig } from "./Render";
export const Fragment = ({children}:IConfig)=>
{   
    return (
           <>{children}</>
    );
}